// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2LnuY","bigColWidth":"Table_bigColWidth__1xbN7","biggerColWidth":"Table_biggerColWidth__2X26M","row":"Table_row__133Fm","col":"Table_col__2ZD0s"};